import type { MessageUnreadSummaryType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useMessageUnreadSummary = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  return useQuery({
    queryKey: [user?.uid, business?.id, ServerStateKeys.MessageUnread],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: "messages/unread-summary",
      }).then(
        (response) =>
          apiV2AssertResponse<MessageUnreadSummaryType>(response).data,
      ),
    refetchIntervalInBackground: false,
    ...getDefaultQueryOptionsV2<MessageUnreadSummaryType>({
      context: { scope: "businessMember", user, business },
      options: {
        refetchInterval: 10 * 60 * 1000,
        retry: (failureCount, error) => {
          const status = error.response?.status;
          return !(status && status >= 400 && status < 500) && failureCount < 2;
        },
      },
    }),
  });
};
